






































import Vue from 'vue'
import { FeedbackTemplateModel } from '@/models/FeedbackTemplateModel'

export default Vue.extend({
  name: 'ShareTextField',
  components: {},
  props: {
    value: {
      default: '',
      type: String,
      required: true
    },
    showUrl: {
      default: true,
      type: Boolean,
      required: false
    },
    buttonText: {
      default: 'Copy',
      type: String,
      required: false
    },
    collapsedButtonText: {
      default: 'Copy sharing link',
      type: String,
      required: false
    }
  },
  data: () => ({
    showCopiedConfirmation: false
  }),
  methods: {
    copyToClip (e: any) {
      this.$copyText(this.value || '')
      this.showCopiedConfirmation = true
    }
  },
  mounted () {
  }
})
